import React, { Component } from "react";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { bindActionCreators } from "redux";
import { SearchLink } from "./SearchLink";

const mapStateToProps = (store) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

class SearchResultByASN extends Component {
  render() {
    const { data } = this.props;
    const {
      as_number,
      as_name,
      as_country_code,
      as_registry,
      as_allocated_date,
    } = data;

    return (
      <div>
        <ReactTable
          showPagination={false}
          pageSize={1}
          data={[
            {
              as_number: <SearchLink searchTerm={as_number} />,
              as_name,
              as_country_code,
              as_registry,
              as_allocated_date,
            },
          ]}
          columns={[
            { Header: "ASN", accessor: "as_number" },
            { Header: "CC", accessor: "as_country_code" },
            { Header: "Registry", accessor: "as_registry" },
            { Header: "Allocated", accessor: "as_allocated_date" },
            { Header: "AS Name", accessor: "as_name" },
          ]}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchResultByASN);
